import { Parchment } from 'quill/core';

export default new Parchment.Attributor(
  'version-change',
  'data-version-change',
  {
    scope: Parchment.Scope.INLINE_ATTRIBUTE,
  },
);
